export const generateUid = (): string => `f${(+new Date()).toString(16)}`;
